import React from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import { useAuth } from '../../contexts';
import { type RoleSwitchBarProps } from './types';
import { handleMapping, handleRoleNavigation } from './roles';
import { ROLES_SWITCH_BAR_TEXT } from './lang';

export const RoleSwitchBar: React.FC<RoleSwitchBarProps> = (
  props: RoleSwitchBarProps,
) => {
  const { open, anchorEl, handleClose } = props;
  const { user, role: currentRole, setCurrentRole } = useAuth();
  const roles = user?.role as string[];

  const handleNavigation = (role: string) => () => {
    localStorage.removeItem('delegateToken');
    setCurrentRole(role);
    handleRoleNavigation(role);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      id="role-switch-bar"
      onClose={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          backgroundColor: '#FFF4F4',
          borderRadius: '0.5rem',
          padding: '0.6rem',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1,
          ml: -11,
        },
      }}
    >
      <Typography variant="body2" sx={{ textAlign: 'center' }} color="#951D1D">
        {ROLES_SWITCH_BAR_TEXT.SWITCH_ROLE}
      </Typography>

      {roles.map((role, index) => (
        <MenuItem
          key={index}
          onClick={handleNavigation(role)}
          sx={{
            cursor: 'pointer',
            fontSize: 14,
            backgroundColor: role === currentRole ? '#951D1D' : '#FFFFFF',
            color: role === currentRole ? '#FFFFFF' : '#951D1D',
            marginY: '0.6rem',
            borderRadius: '1rem',
            padding: '0.6rem',
            border: '2px solid #951D1D',
            display: 'flex',
            minWidth: 180,
            justifyContent: 'center',
            textAlign: 'center',
            '&:hover, &:focus': {
              backgroundColor: '#951D1D',
              color: '#FFFFFF',
            },
          }}
        >
          {ROLES_SWITCH_BAR_TEXT.NAMING[handleMapping(role)]}
        </MenuItem>
      ))}
    </Menu>
  );
};
